import React from "react";
import InputLabel from "@mui/material/InputLabel";
import { FormControl, InputBase } from "@mui/material";
import { Colors } from "../../assets/colors/Colors";
import { isEmpty } from "../../util/is";
import { Controller } from "react-hook-form";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
	"label + &": {
		marginTop: theme.spacing(3),
	},
	".MuiInputBase-input.Mui-disabled": {
		WebkitTextFillColor: "rgba(0, 0, 0, 1)",
		// color: 'rgba(0, 0, 0, 0.5)'
	},
	"& .MuiInputBase-input": {
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		boxShadow: "0 2px 5px 0 rgb(0 0 0 / 4%)",
		border: "1px solid #ced4da",
		fontSize: 14,
		padding: "8px 26px 8px 10px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:focus": {
			borderRadius: 4,
			borderColor: "#1976d2",
		},
	},
}));

const InputForm = ({
	identificador,
	multiline = false,
	placeholder,
	label,
	value = "",
	handleChange,
	width = `100%`,
	disabled = false,
	className = "classDefaultForm",
	type = "text",
	inputProps = {},
	required = false,
	readOnly = false,
	rules = {},
	customError = null,
	nestedValue = null,
	textUppercase = true,
	style = {},
}) => {
	return (
		<FormControl key={`key${identificador}`} variant='outlined' className={`my-1 ${className}`}>
			<Tooltip title={`${required ? `*${label}` : `${label}`}`}>
				<InputLabel
					shrink
					htmlFor={identificador}
					style={{
						width,
						fontWeight: "bold",
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap",
						pointerEvents: "auto",
					}}
				>
					{`${required ? `*${label}` : `${label}`}`}
				</InputLabel>
			</Tooltip>

			{!("control" in inputProps) ? (
				<BootstrapInput
					type={type}
					readOnly={readOnly}
					disabled={disabled}
					name={identificador}
					multiline={multiline}
					placeholder={placeholder}
					onWheel={(e) => e.target.blur()}
					// value={value || (type === "number" ? "0" : "")}
					value={value}
					onChange={({ target: { name, value } }) => handleChange({ name, value })}
					style={{ marginTop: 9, marginBottom: 4, width, maxWidth: "100%", ...style }}
					inputProps={{ ...inputProps, step: inputProps?.step, maxLength: inputProps?.maxLength }}
				/>
			) : (
				<Controller
					name={identificador}
					control={inputProps.control}
					rules={{ required: required, ...rules }}
					defaultValue={type === "number" ? "0" : ""}
					render={({ field: { onChange, onBlur, value } }) => (
						<BootstrapInput
							type={type}
							onBlur={onBlur}
							readOnly={readOnly}
							disabled={disabled}
							name={identificador}
							multiline={multiline}
							placeholder={placeholder}
							value={nestedValue ? nestedValue : isEmpty(value) ? "" : value}
							inputProps={{
								step: "1",
								maxLength: inputProps?.maxLength,
								style: { textTransform: textUppercase ? "uppercase" : "none" },
							}}
							onChange={({ target: { value } }) =>
								onChange(type === "text" ? (textUppercase ? value?.toString()?.toUpperCase() : value) : value)
							}
							className={`mx-1`}
							style={{ marginTop: 9, marginBottom: 4, width, maxWidth: "100%", ...style }}
						/>
					)}
				/>
			)}
			{(!isEmpty(customError) || required) && <span className='mt-1 pl-2 titleForm panelColorError'>{customError}</span>}
		</FormControl>
	);
};

export default InputForm;
